import React, { useState, useEffect } from "react";
import { Play, X } from "lucide-react";

export default function VideoCard({ video }) {
    const [open, setOpen] = useState(false);
    const thumb =
        video.thumbnail ||
        `https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg`;

    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && setOpen(false);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open]);

    return (
        <>
            <article
                data-testid={`video-card-${video.id}`}
                className="group cursor-pointer"
                onClick={() => setOpen(true)}
            >
                <div className="relative overflow-hidden aspect-video bg-tattva-surface">
                    <img
                        src={thumb}
                        alt={video.title}
                        className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
                        onError={(e) => {
                            const el = e.currentTarget;
                            if (!el.dataset.fb) {
                                el.dataset.fb = "1";
                                el.src = `https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg`;
                            }
                        }}
                    />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 bg-tattva-ink/20 transition-opacity duration-500">
                        <div className="w-14 h-14 bg-tattva-bg flex items-center justify-center">
                            <Play
                                size={22}
                                className="text-tattva-terracotta"
                                fill="#C25934"
                            />
                        </div>
                    </div>
                    {video.duration && (
                        <span className="absolute bottom-3 right-3 text-[10px] uppercase tracking-widest bg-tattva-ink/80 text-tattva-bg px-2 py-1">
                            {video.duration}
                        </span>
                    )}
                </div>
                <div className="mt-5">
                    <p className="text-[10px] uppercase tracking-[0.25em] text-tattva-muted mb-2">
                        {video.category}
                    </p>
                    <h3 className="font-serif text-xl md:text-2xl text-tattva-ink leading-snug group-hover:text-tattva-terracotta transition-colors">
                        {video.title}
                    </h3>
                    <p className="text-sm text-tattva-muted mt-2 leading-relaxed line-clamp-2">
                        {video.description}
                    </p>
                </div>
            </article>

            {open && (
                <div
                    data-testid="video-modal"
                    className="fixed inset-0 z-50 bg-tattva-ink/80 backdrop-blur-sm flex items-center justify-center p-4 md:p-10"
                    onClick={() => setOpen(false)}
                >
                    <button
                        className="absolute top-6 right-6 text-tattva-bg"
                        onClick={() => setOpen(false)}
                        aria-label="Close"
                        data-testid="video-modal-close"
                    >
                        <X size={28} />
                    </button>
                    <div
                        className="w-full max-w-5xl aspect-video bg-black"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <iframe
                            className="w-full h-full"
                            src={`https://www.youtube.com/embed/${video.youtube_id}?autoplay=1&rel=0`}
                            title={video.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            )}
        </>
    );
}
